import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { ButtonIcon } from 'components/button';
import { TableCell } from 'components/table';
import { ORDER_BY } from 'components/table/constants';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import DataTableContext from './DataTableContext';

import './DataTableHeaderCell.scss';

class DataTableHeaderCell extends PureComponent {
  // #region set up
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    onCellClick: PropTypes.func,
    orderBy: PropTypes.string,
    sortName: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.changeSort = this.changeSort.bind(this);
  }
  // #end region

  // #region actions
  changeSort(onChangeSort) {
    const { sortName, orderBy } = this.props;

    const newOrderBy =
      orderBy === ORDER_BY.ASC || !orderBy ? ORDER_BY.DESC : ORDER_BY.ASC;

    onChangeSort && onChangeSort({ [sortName]: newOrderBy });
  }
  // #endregion

  get icon() {
    const { orderBy } = this.props;

    return orderBy ? 'triangle-up' : 'arrow-up-down';
  }

  // #region render
  render() {
    const { className, onCellClick } = this.props;
    const classComponent = classNames('data-table-header-cell', className);

    return (
      <TableCell
        role="columnheader"
        className={classComponent}
        onClick={onCellClick}
      >
        {this.renderInner()}
      </TableCell>
    );
  }

  renderInner() {
    const { orderBy = 'none', sortName } = this.props;

    if (!sortName) {
      return this.inner;
    }

    return (
      <DataTableContext.Consumer>
        {({ actions }) => (
          <ButtonIcon
            className={`orderby-button-icon ${orderBy}`}
            icon={this.icon}
            onClick={() => this.changeSort(actions.onChangeSort)}
            pos="right"
            transparent
          >
            {this.inner}
          </ButtonIcon>
        )}
      </DataTableContext.Consumer>
    );
  }

  get inner() {
    const { children, label } = this.props;

    return label ? <I18n label={label} html /> : children;
  }
  // #endregion
}

export default DataTableHeaderCell;
